import { applyInfo, applySteps, festivalInfo } from "@/mocks/festival";

const guideRows = [
  { label: "운영 일시", value: festivalInfo.dateText },
  { label: "운영 회차", value: applyInfo.rounds.join(" / ") },
  { label: "체험 장소", value: festivalInfo.venue },
  { label: "참가 대상", value: "축제를 찾는 방문객 누구나 (가족 단위 환영)" },
  { label: "참가 정원", value: applyInfo.capacity },
  { label: "참가 비용", value: applyInfo.feeNote },
];

export default function ApplyGuide() {
  return (
    <section className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="reveal mb-10 md:mb-14">
          <span className="text-xs tracking-[0.24em] text-primary-600">HOW TO APPLY</span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl leading-tight text-foreground-950">
            신청 전 확인해 주세요
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div className="reveal">
            <div className="w-full aspect-[4/3] overflow-hidden rounded-lg">
              <img
                src={applyInfo.image.src}
                alt={applyInfo.image.alt}
                width={1100}
                height={780}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {applySteps.map((step, i) => (
                <div
                  key={step.no}
                  className={`reveal reveal-delay-${i + 1} rounded-lg border border-background-200 bg-background-100 px-5 py-5`}
                >
                  <span className="font-heading text-xl text-accent-600">{step.no}</span>
                  <strong className="mt-2 block text-sm text-foreground-950">{step.title}</strong>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal reveal-delay-2 rounded-lg bg-primary-50 border border-primary-100 p-6 md:p-8">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-white text-xl">
                <i className="ri-plant-line"></i>
              </span>
              <div>
                <strong className="block font-heading text-lg text-foreground-950">{applyInfo.programName}</strong>
                <span className="text-xs text-foreground-600">프로그램 안내</span>
              </div>
            </div>

            <dl className="mt-6 flex flex-col">
              {guideRows.map((row) => (
                <div
                  key={row.label}
                  className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4 border-t border-primary-100 py-3.5 first:border-t-0 sm:first:border-t"
                >
                  <dt className="w-full sm:w-28 shrink-0 text-xs tracking-[0.12em] text-primary-700 pt-0.5">
                    {row.label}
                  </dt>
                  <dd className="text-sm leading-relaxed text-foreground-800">{row.value}</dd>
                </div>
              ))}
            </dl>

            <p className="mt-6 rounded-lg bg-accent-50 border border-accent-200/70 px-4 py-3 text-xs leading-relaxed text-accent-900">
              수확한 포도는 현장 안내에 따라 포장해 드립니다. 편한 복장과 신발로 방문해 주세요.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}